import { Card, CardActionArea, CardContent, Typography } from "@mui/material";

const MarketGrowthStatCard = ({ label, value, subtitle, onClick, highlight = false }) => {
  const content = (
    <CardContent>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h6" fontWeight={700} sx={{ mt: 0.5 }}>
        {value}
      </Typography>
      {subtitle ? (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      ) : null}
    </CardContent>
  );

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        ...(highlight
          ? {
              borderColor: "warning.main",
              bgcolor: "warning.50",
            }
          : null),
      }}
    >
      {onClick ? (
        <CardActionArea onClick={onClick} sx={{ height: "100%" }}>
          {content}
        </CardActionArea>
      ) : (
        content
      )}
    </Card>
  );
};

export default MarketGrowthStatCard;
